import React from "react";
import Header from "./components/Header/Header";
import Home from "./components/Home/Home";
import Footer from "./components/Footer/Footer";
import About from "./components/About/About";
import './App.css';
import Skills from "./components/Skills/Skills";
import Experience from "./components/Experience/Experience";
import Projects from "./components/Projects/Projects";
import Contact from "./components/Contact/Contact";
import ScrollUp from "./components/ScrollUp/ScrollUp";
const App = () => {
  return (
    <div className="content">
      <Header />
      <div className="main_body">
        <Home />
        <About/>
        <Experience />
        <Skills />
        <Projects/>
        <Contact/>
      </div>

      <Footer />
      <ScrollUp/>
    </div>);
};

export default App;
